import { WorkspaceLayout } from './layout';

import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { useTrack } from '@/shared/track/use-track';

export function WorkspaceLayoutRoute() {
  const { workspaceId } = useWorkspaceId();
  useTrack();
  return <WorkspaceLayout workspaceId={workspaceId} />;
}
